import { Spin } from "antd";
import { VideoCameraOutlined, CloseOutlined } from "@ant-design/icons";
import { Button } from "antd";
import styles from "./styles.module.less";

interface VideoPreviewProps {
  fileUrl?: string;
  isUploading: boolean;
  onRemove?: () => void;
}

export const VideoPreview = ({
  fileUrl,
  isUploading,
  onRemove,
}: VideoPreviewProps) => {
  return (
    <div className={styles.imagePreview}>
      <div className={styles.uploadingPlaceholder}>
        {fileUrl ? (
          <video
            src={fileUrl}
            className={styles.previewImage}
            controls={!isUploading}
            muted={isUploading}
            preload="metadata"
          />
        ) : (
          <div className={styles.videoSkeleton}>
            <div className={styles.videoSkeletonIcon}>
              <VideoCameraOutlined className={styles.videoIcon} />
            </div>
            <div className={styles.videoSkeletonBars}>
              <div
                className={styles.videoBar}
                style={{ animationDelay: "0s" }}
              />
              <div
                className={styles.videoBar}
                style={{ animationDelay: "0.1s" }}
              />
              <div
                className={styles.videoBar}
                style={{ animationDelay: "0.2s" }}
              />
              <div
                className={styles.videoBar}
                style={{ animationDelay: "0.3s" }}
              />
              <div
                className={styles.videoBar}
                style={{ animationDelay: "0.4s" }}
              />
            </div>
          </div>
        )}
        {isUploading && (
          <div className={styles.uploadingOverlay}>
            <Spin size="large" />
            <span className={styles.uploadingText}>Đang tải...</span>
          </div>
        )}
      </div>
      {!isUploading && onRemove && (
        <Button
          type="text"
          icon={<CloseOutlined />}
          className={styles.removeButton}
          onClick={onRemove}
        />
      )}
    </div>
  );
};
